import DOMPurify from 'dompurify';

// Product descriptions are tenant-authored HTML that we render with dangerouslySetInnerHTML.
// Sanitise before rendering so a malicious/compromised user can't inject <script>, event
// handlers, or javascript: URLs that would run in another user's session (the Supabase session
// token lives in localStorage, so an XSS would be an account-takeover vector).
export function sanitizeHtml(html) {
  if (html === null || html === undefined) return '';
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },   // allow only standard, safe HTML elements/attributes
    ADD_ATTR: ['target', 'rel'],
    FORBID_TAGS: ['style', 'form', 'input', 'button'],
    FORBID_ATTR: ['style'],
  });
}
